import {
  GenerateCloseoutTradesFromHedgesRequestPayload,
  GetExposureCalculationDataRequestPayload,
  GetHedgeNotionalRequestPayload,
  GetProposedTradesRequestPayload,
  SendProposedTradesRequestPayload,
} from '@/pages/Rebalancing/components/ExposureCalculation/store/actions';
import {
  ExpoClassLimitRequestPayload,
  ExposureApprovalRequestPayload,
  UploadExposureFileRequestPayload,
} from '@/pages/Rebalancing/components/ExposureCapture/store/actions';
import {
  BulkDealNameUpdateRequestPayload,
} from '@/pages/TradeCenter/store/bulkDealNameUpdate/action';
import { SetTradeClassTagRequestPayload } from '@/pages/TradeCenter/store/actions';
import { AxiosInstance } from 'axios';

export default class FundLevelHedgingAPI {
  client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }
  async getTradeClassTagData(transaction_id: number) {
    return this.client.get(
      `v2/fund-level-hedging/transaction_classification/${transaction_id}`,
    );
  }

  async setTradeClassTagData(payload: SetTradeClassTagRequestPayload) {
    return this.client.post(
      `v2/fund-level-hedging/associate-transaction_classification/`,
      payload,
    );
  }

  /* Exposure capture apis */
  async getAllExposureData() {
    return this.client.get(`v2/fund-level-hedging/get-all-exposure-data`);
  }

  async getAllExposureClassData() {
    return this.client.get(
      `v2/fund-level-hedging/get-all-exposure-class-tag-data`,
    );
  }

  async expoClassLimits(payload: ExpoClassLimitRequestPayload) {
    return this.client.post(
      `v2/fund-level-hedging/update-expo-classification-limits/`,
      payload,
    );
  }
  async postExposureApproval(payload: ExposureApprovalRequestPayload) {
    return this.client.post(
      `v2/fund-level-hedging/insert-exposure-approval-decision/`,
      payload,
    );
  }
  async uploadExposureData(payload: UploadExposureFileRequestPayload) {
    const formData = new FormData();
    formData.append('file', payload.file);

    return this.client.post(
      `v2/fund-level-hedging/upload-exposure-data/`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );
  }

  // exposure calculation apis
  async getFundFilterData() {
    return this.client.get(`v2/fund-level-hedging/get-fund-filter-data`);
  }
  async getExposureCalculationData(
    payload: GetExposureCalculationDataRequestPayload,
  ) {
    return this.client.post(
      `v2/fund-level-hedging/get-all-hedge-notionals-exposure-data/`,
      payload,
    );
  }
  async getHedgeNotionalData(payload: GetHedgeNotionalRequestPayload) {
    return this.client.post(
      `/v2/fund-level-hedging/get-all-hedge-notionals-data/`,
      payload,
    );
  }
  async getProposedTrades(payload: GetProposedTradesRequestPayload) {
    return this.client.post(
      '/v2/fund-level-hedging/get-trades-for-exposures-page/',
      payload,
    );
  }
  /* Sends proposed trades to workflow */
  async saveProposedTrades(payload: SendProposedTradesRequestPayload) {
    return this.client.post(
      '/v2/fund-level-hedging/save-proposed-trades/',
      payload,
    );
  }
  async downloadExposureCalculationReport() {
    return this.client.post(
      '/v2/fund-level-hedging/download-asset-exposure-report/',
    );
  }

  async getTransactionMidsData(payload: any) {
    return this.client.post('v2/fund-level-hedging/transaction-mids-data/', payload);
  }

  async uploadBlotter(file: File) {
    const formData = new FormData();
    formData.append('file', file);

    return this.client.post(
      'v2/fund-level-hedging/upload-blotter/',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );
  }

  async generateCloseoutTradesFromHedges(
    payload: GenerateCloseoutTradesFromHedgesRequestPayload,
  ) {
    return this.client.post(
      'v2/fund-level-hedging/generate-closeout-trades/',
      payload,
    );
  }

  async downloadBulkDealNameUpdateTemplate() {
    return this.client.get(
      '/v2/fund-level-hedging/bulk-deal-name-update-template/',
    );
  }

  async submitBulkDealNameUpdate(payload: BulkDealNameUpdateRequestPayload) {
    return this.client.post(
      '/v2/fund-level-hedging/bulk-deal-name-update/',
      payload,
    );
  }
}
